import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/fr';

// Configure dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.locale('fr');

const DayjsFormat = ({ children, format, fromNow, ...props }) => {
  const date = dayjs(children);

  let formattedDate;

  if (fromNow) {
    formattedDate = date.fromNow();
  } else if (format) {
    formattedDate = date.format(format);
  } else {
    formattedDate = date.toString();
  }
  return <span {...props}>{formattedDate}</span>;
};

DayjsFormat.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.number,
  ]).isRequired,
  format: PropTypes.string,
  fromNow: PropTypes.bool,
  locale: PropTypes.string,
  interval: PropTypes.number,
};

export default DayjsFormat;
